module.exports = __webpack_public_path__ + "static/media/g3.28c2ba9a.jpg";